var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReferralsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.719 3.067a3.884 3.884 0 00-1.623-.981 3.855 3.855 0 00-3.598.723c-.495.41-.881.938-1.126 1.535a3.965 3.965 0 00.36 3.687c.356.537.838.977 1.402 1.282a3.861 3.861 0 003.102.249",
    stroke: "#B9BBC6",
    strokeWidth: 1.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.698 13.329c2.856 0 5.172-2.338 5.172-5.223s-2.316-5.223-5.172-5.223c-2.857 0-5.173 2.338-5.173 5.223s2.316 5.223 5.173 5.223z",
    stroke: "#B9BBC6",
    strokeWidth: 1.7,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.69 22.083h7.916c.992 0 1.703-1.1 1.411-2.18a6.698 6.698 0 00-1.185-2.464 6.624 6.624 0 00-2.066-1.776 1.804 1.804 0 00-1.289-.14 7.505 7.505 0 01-3.586 0 1.804 1.804 0 00-1.278.14 6.11 6.11 0 00-2.11 1.841M5.443 16.073l.016 2.807a2.68 2.68 0 00.779 1.877 2.628 2.628 0 001.862.776h1.76",
    stroke: "#B9BBC6",
    strokeWidth: 1.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.685 18.016L4.79 15.89a.936.936 0 011.322 0l2.264 2.292M1.917 14.812c0-.665.26-1.302.726-1.773a2.473 2.473 0 011.754-.737h4.25",
    stroke: "#B9BBC6",
    strokeWidth: 1.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
export default SvgReferralsIcon;